'use strict';

var React = require('react/addons');
var classSet = React.addons.classSet;

var Reflux = require('reflux');
var ckeditor = require('ckeditor');

/* Stores */
var LanguageStore = require('stores/language');
var TranslationEditorStore = require('stores/translation-editor');
var ModuleInspectorStore = require('stores/module-inspector');

/* Actions */
var TranslationEditorActions = require('actions/translation-editor');

/* Components */
var Modal = require('components/ui/modal');
var ButtonGroup = require('components/ui/button-group');
var Button = require('components/ui/button');
var TextField = require('components/ui/text-field');
var LinkEditor = require('./link-editor');
var TranslationHelper = require('./translation-helper');

var TranslationEditor = React.createClass({
  displayName: 'TranslationEditor',

  getInitialState: function getInitialState() {
    return {
      // Will fail unless there is at least some state
      editingLink: false,
      showHelper: false
    };
  },

  // The Squire text editor loads in an iframe so we need to listen for
  // when it has loaded and then get and save a reference to it.
  componentDidMount: function componentDidMount() {
    // let component = this

    // A fix for the react bug where an iframe will not call the onload event
    // we could remove this when the bug is fixed
    // React bug #1718: https://github.com/facebook/react/issues/1718
    // let editorFrame = component.refs.editor.getDOMNode()
    // editorFrame.onload = component._onEditorLoad

    this._bindEditor();
  },

  componentWillUnmount: function componentWillUnmount() {
    // let component = this

    // Since the Squire text editor runs in an iframe we get an error after
    // the component is unmounted if we're still attached to the input event
    // let editor = component.editor
    // editor.removeEventListener('input', component._onEditorInput)
  },

  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    // let component = this

    // When the user selects a translation we need to update the content of
    // the CKEditor text editor.
    if (prevProps.selectedTranslation !== this.props.selectedTranslation) {
      this.editor.setData(TranslationEditorStore.value[this.props.selectedTranslation]);
    }
  },

  render: function render() {
    var component = this;
    var props = component.props;
    var state = component.state;
    var translations = props.translations;
    var selectedTranslation = props.selectedTranslation;
    var editingLink = state.editingLink;
    var showHelper = state.showHelper;

    var baseTranslationKey = 'translation_editor_';

    var translationNodes = translations.map(function (translation) {
      var value = TranslationEditorStore.value[translation] || '';
      var selected = translation === selectedTranslation;

      var hasValue = value.length ? true : false;
      // TODO: Set a class indicating no value for styling

      var nameTranslation = ModuleInspectorStore.translate(TranslationEditorStore.baseTranslationKey + '_' + translation);
      var classes = {};
      classes['item-component'] = true;
      classes['selected'] = selected;

      return React.createElement(
        'div',
        {
          key: translation,
          className: classSet(classes),
          onClick: component._onTranslationClick.bind(null, translation) },
        React.createElement(
          'div',
          { className: 'subtitle' },
          nameTranslation
        ),
        React.createElement('div', { className: 'title', dangerouslySetInnerHTML: { __html: value } })
      );
    });

    var linkEditingComponent = null;

    if (editingLink) {
      var _onRemoveLinkClick = component._onRemoveLinkClick;
      var _onSaveLinkClick = component._onSaveLinkClick;
      var _onCancelLinkClick = component._onCancelLinkClick;
      var edit = editingLink.edit;

      var url = '';

      if (edit) {
        var anchor = null;
        var elem = editingLink.selection.startContainer;
        while (!anchor) {
          if (elem.nodeName === 'A') {
            anchor = elem;
            break;
          }

          elem = elem.parentElement;
        }

        if (anchor) {
          url = anchor.href;
        }
      }

      /* Translations */
      var titleTranslationKey = edit ? 'edit_link' : 'add_link';

      linkEditingComponent = React.createElement(LinkEditor, {
        ref: 'linkEditor',
        url: url,
        title: titleTranslationKey,
        onCancel: _onCancelLinkClick,
        onSaveLink: _onSaveLinkClick,
        onRemoveLink: _onRemoveLinkClick });
    }

    var value = TranslationEditorStore.value[this.props.selectedTranslation];
    var defaultValue = ModuleInspectorStore.getDefaultTranslation(TranslationEditorStore.groupName, this.props.selectedTranslation) || null;
    var example = ModuleInspectorStore.translate(TranslationEditorStore.baseTranslationKey + '_' + this.props.selectedTranslation + '_example', null, true);
    var variables = ModuleInspectorStore.translate(TranslationEditorStore.baseTranslationKey + '_' + this.props.selectedTranslation + '_variables', null, true);

    var helperButton = React.createElement('div', null);
    if (defaultValue || example || variables) {
      helperButton = React.createElement('div', {
        className: 'helper-button',
        onClick: this._onToggleHelperClick });
    }

    var helper = null;
    if (showHelper) {
      helper = React.createElement(TranslationHelper, {
        defaultValue: defaultValue,
        example: example,
        variables: variables,
        onClick: this._onToggleHelperClick });
    }

    return React.createElement(
      'div',
      null,
      React.createElement(
        Modal,
        { className: 'translation-editor-component', onCancel: component._onCancelClick },
        React.createElement(
          'div',
          { className: 'sidebar' },
          React.createElement(
            'div',
            { className: 'list-component' },
            translationNodes
          ),
          React.createElement(
            ButtonGroup,
            null,
            React.createElement(Button, { translationKey: 'cancel', className: 'cancel', onClick: component._onCancelClick }),
            React.createElement(Button, { translationKey: 'save', className: 'submit', onClick: component._onSaveClick })
          )
        ),
        React.createElement(
          'div',
          { className: 'content' },
          React.createElement(
            'div',
            { className: 'editor-wrapper' },
            React.createElement('textarea', { className: 'editor ckeditor', ref: 'editor', defaultValue: value }),
            { helperButton: helperButton }
          )
        )
      ),
      { helper: helper }
    );
  },

  _bindEditor: function _bindEditor() {
    this.editor = ckeditor.inline(this.refs.editor.getDOMNode());
    this.editor.on('change', this._onEditorChange);
  },

  _onEditorChange: function _onEditorChange() {
    var html = this.editor.getData();

    TranslationEditorActions.updateTranslation(html);
  },

  _onTranslationClick: function _onTranslationClick(translation) {
    TranslationEditorActions.selectTranslation(translation);
  },

  _onCancelClick: function _onCancelClick() {
    TranslationEditorActions.cancel();
  },

  _onSaveClick: function _onSaveClick() {
    var component = this;
    var editor = component.editor;

    var html = editor.getData();

    TranslationEditorActions.save();
  },

  _onEditorLoad: function _onEditorLoad() {
    var component = this;
    var editorFrame = component.refs.editor.getDOMNode();

    var editor = editorFrame.contentWindow.editor;

    component.editor = editor;

    editor.defaultBlockTag = 'P';
    editor.setHTML(TranslationEditorStore.value[component.props.selectedTranslation]);
    editor.addEventListener('input', component._onEditorInput);
    editor.addEventListener('willPaste', component._onEditorWillPaste);
  },

  _onEditorWillPaste: function _onEditorWillPaste(evt) {
    evt.preventDefault();

    var fragment = evt.fragment;
    var textContent = fragment.textContent;

    var component = this;
    var editorFrame = component.refs.editor.getDOMNode();
    var editor = editorFrame.contentWindow.editor;

    editor.setHTML(textContent);
  },

  _onEditorInput: function _onEditorInput() {
    var component = this;
    var html = component.editor.getHTML();

    // Clean up the surrounding divs
    var elem = document.createElement('div');
    elem.innerHTML = html;
    html = Array.prototype.map.call(elem.childNodes, function (node) {
      return node.innerHTML;
    }).join('').trim('<br>');

    TranslationEditorActions.updateTranslation(html);
  },

  _onToolbarBoldClick: function _onToolbarBoldClick() {
    var editor = this.editor;
    if (editor.hasFormat('b')) {
      editor.removeBold();
    } else {
      editor.bold();
    }
  },

  _onToolbarItalicClick: function _onToolbarItalicClick() {
    var editor = this.editor;
    if (editor.hasFormat('i')) {
      editor.removeItalic();
    } else {
      editor.italic();
    }
  },

  _onToolbarUnderlineClick: function _onToolbarUnderlineClick() {
    var editor = this.editor;
    if (editor.hasFormat('u')) {
      editor.removeUnderline();
    } else {
      editor.underline();
    }
  },

  _onToolbarUnorderedListClick: function _onToolbarUnorderedListClick() {
    var editor = this.editor;
    if (editor.hasFormat('ul')) {
      editor.removeList();
    } else {
      editor.makeUnorderedList();
    }
  },

  _onToolbarOrderedListClick: function _onToolbarOrderedListClick() {
    var editor = this.editor;
    if (editor.hasFormat('ol')) {
      editor.removeList();
    } else {
      editor.makeOrderedList();
    }
  },

  _onToolbarLinkClick: function _onToolbarLinkClick() {
    var component = this;
    var editor = component.editor;
    var selectedText = editor.getSelectedText();
    var path = editor.getPath();
    var html = editor.getHTML();
    var selection = editor.getSelection();
    var edit = editor.hasFormat('a');

    component.setState({ editingLink: { selectedText: selectedText, selection: selection, html: html, path: path, edit: edit } });
  },

  _onSaveLinkClick: function _onSaveLinkClick() {
    var component = this;
    var editor = component.editor;
    var refs = component.refs;

    var url = refs.linkEditor.value;

    if (url.length) {
      editor.makeLink(url);
    } else {
      editor.removeLink();
    }

    component.setState({ editingLink: false });
  },

  _onRemoveLinkClick: function _onRemoveLinkClick() {
    var component = this;
    var editor = component.editor;

    editor.removeLink();
    component.setState({ editingLink: false });
  },

  _onCancelLinkClick: function _onCancelLinkClick() {
    var component = this;

    component.setState({ editingLink: false });
  },

  _onToggleHelperClick: function _onToggleHelperClick() {
    this.setState({
      showHelper: !this.state.showHelper
    });
  }
});

module.exports = TranslationEditor;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/translation-editor.js
 **/